export const FTPNodeDefaults = {
  operation: 'download',
  path: '/',
  directory: '/',
  filename: '',
  filenamePattern: '',
  deleteOptions: {
    folder: false,
    recursive: false
  },
  downloadOptions: {
    dataPropertyName: 'data'
  },
  listOptions: {
    recursive: false
  },
  renameOptions: {
    oldPath: '',
    newPath: '',
    createDirectories: false
  },
  uploadOptions: {
    binaryFile: true,
    binaryPropertyName: 'data',
    textContent: ''
  }
};
